


















































































































import { Component, Vue } from 'vue-property-decorator';
import { workspaceService } from '@/services/WorkspaceService';
import { mapState } from 'vuex';
import EventBus from '../../EventBus';
import { clientDataService } from '../../services/ClientDataService';

@Component({
  props: ['isPreproduct'],
  computed: {
    ...mapState({
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class RemoveWorkspaceDialog extends Vue {
  isModalShown = false;
  isLoading = false;
  workspaceId = 0;
  isMailSendSuccessfully = false;
  isRequestSendSuccessfully = false;
  isWorkspaceRemovalToken = false;
  token = '';
  isInvalidToken = false;
  hasRemovalStarted = false;
  isContract = false;
  isBtnDisabled = false;
  subject: any = '';
  formDescription: any = '';

  onClose() {
    this.isModalShown = false;
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.subject = this.$t('settings.removeWorkspaceRequest');
    this.formDescription = this.$t('settings.removeWorkspaceMessageSent');
    this.token = this.$route.params.token;
    if (this.token) {
      this.isModalShown = true;
      this.isWorkspaceRemovalToken = true;
    }
    EventBus.$on('workspace-delete-success', () => {
      this.isModalShown = false;
    });
    EventBus.$on('workspace-delete-failed', () => {
      this.isModalShown = false;
    });
    clientDataService
      .getClientData(this.workspaceId)
      .then(data => {
        this.isContract = data.contract;
      })
      .catch(() => {});
  }
  closeModal() {
    this.isRequestSendSuccessfully = false;
  }
  sendRequest() {
    const data = new FormData();
    data.append('type', this.subject);
    data.append('description', this.formDescription);

    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .createTicket(this.workspaceId, data)
      .then(() => {
        this.isLoading = false;
        this.isRequestSendSuccessfully = true;
        this.isBtnDisabled = true;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  sendRemoveConfirmationEmail() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .sendWorkspaceRemoveEmail(this.workspaceId)
      .then(() => {
        this.isLoading = false;
        this.isMailSendSuccessfully = true;
      })
      .catch(() => {
        this.isLoading = false;
        this.isMailSendSuccessfully = false;
      });
  }
  removeWorkspace() {
    if (this.isLoading || this.hasRemovalStarted) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .removeWorkspace(this.workspaceId, this.token)
      .then(() => {
        this.isLoading = false;
        this.hasRemovalStarted = true;
      })
      .catch(data => {
        this.isLoading = false;
        this.hasRemovalStarted = false;
        if (data && data.data && data.status === 403) {
          if (data.data.error === 'invalid_token') {
            this.isInvalidToken = true;
          }
        }
      });
  }
}
